import { AnswerStatementRequest, PostStatementRequest, PutStatementRequest } from '../types/formdataTypes';
import {
	PutStatementDeadlineRequest,
	PutStatementStateRequest,
	StatementEmailReminderRequest,
	StatementResponse,
} from '../types/types';
import { HttpResponse, makeRequest } from './index';
const endpoint = 'Statement';

export const answerStatement = async (request: AnswerStatementRequest): Promise<HttpResponse<null>> => {
	const formData = new FormData();
	formData.append('statementId', request.statementId);
	formData.append('emailToken', request.emailToken);
	formData.append('answer', request.answer);

	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}

	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}

	const result = await makeRequest<any, null>(`${endpoint}/answer`, formData, 'post', true);
	return result;
};

export const putStatement = async (request: PutStatementRequest): Promise<HttpResponse<null>> => {
	const formData = new FormData();
	formData.append('statementId', request.statementId);
	formData.append('title', request.title);

	if (request.answer) {
		formData.append('answer', request.answer);
	}

	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}

	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}

	if (request.internalNote) {
		formData.append('internalNote', request.internalNote);
	}

	const result = await makeRequest<any, null>(`${endpoint}`, formData, 'put', true);
	return result;
};

export const putStatementDeadline = async (request: PutStatementDeadlineRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<PutStatementDeadlineRequest, null>(`${endpoint}/deadline`, request, 'put');
	return result;
};

export const putStatementState = async (request: PutStatementStateRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<PutStatementStateRequest, null>(`${endpoint}/state`, request, 'put');
	return result;
};

export const getStatement = async (id: string, token?: string): Promise<HttpResponse<StatementResponse>> => {
	const tokenString = token ? `&token=${token}` : '';
	const result = await makeRequest<string, StatementResponse>(`${endpoint}?statementId=${id}${tokenString}`, null, 'get');
	return result;
};

export const sendStatementReminder = async (request: StatementEmailReminderRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<StatementEmailReminderRequest, null>(`${endpoint}/reminder`, request, 'post');
	return result;
};

export const postStatement = async (request: PostStatementRequest): Promise<HttpResponse<StatementResponse>> => {
	const formData = new FormData();
	formData.append('userId', request.userId);
	formData.append('caseId', request.caseId);
	formData.append('title', request.title);
	formData.append('answer', request.answer);
	formData.append('answeredDate', request.answeredDate);
	formData.append('createdDate', request.createdDate);

	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}

	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}

	if (request.internalNote) {
		formData.append('internalNote', request.internalNote);
	}
	const result = await makeRequest<any, StatementResponse>(`${endpoint}`, formData, 'post', true);
	return result;
};

export const deleteStatement = async (id: string): Promise<HttpResponse<null>> => {
	const result = await makeRequest<string, null>(`${endpoint}?statementId=${id}`, null, 'delete');
	return result;
};
